import React from "react";
import { ElementComponentProps } from "elements/types";
import { LookupElement } from "records/Element";
import LookupReactive from "./LookupReactive";
import LookupOnApply from "./LookupOnApply";
import { extractOnApplyParameters } from "elements/utils";

function LookupContainer(props: ElementComponentProps<LookupElement>) {
	const { isOnApplyPropsProvided, requiredOnApplyProps } =
		extractOnApplyParameters(props);
	return isOnApplyPropsProvided ? (
		<LookupOnApply {...props} {...requiredOnApplyProps} />
	) : (
		<LookupReactive {...props} />
	);
}

export default React.memo(LookupContainer);
